import "./AssistSettings.css";
import assistIcon from "../../common/assets/images/assistlist.png";
import { useNavigate } from "react-router-dom";


function ModuleCard({ icon, title, description, buttonLabel,path }) {
  const navigate = useNavigate();
  const handleOpen = () => {
    navigate(path);
  };

  return (
    <div className="assistSettings-module-card">
      <div className="assistSettings-module-left">
        <div className="assistSettings-module-icon">{icon}</div>
        <div className="assistSettings-module-text">
          <p className="assistSettings-module-title">{title}</p>
          <p className="assistSettings-module-desc">{description}</p>
        </div>
      </div>

      {/* Wrapper panel: gives the button its own bg (#F9FAFB) + left border, per spec */}
      <div className="assistSettings-module-action">
        <button className="assistSettings-open-btn" onClick={handleOpen}>{buttonLabel}</button>
      </div>
    </div>
  );
}

export default function AssistSettings() {
  return (
    <div className="assistSettings-page">
      <h1 className="assistSettings-page-title">Assist Settings</h1>
      <p className="assistSettings-page-subtitle">
        Configure and manage settings related to Assist functionality.
      </p>

      <ModuleCard
        icon={
          <img
            src={assistIcon}
            alt="Guidance & Decision Support"
            className="assistSettings-module-icon-img"
          />
        }
        title="Guidance & Decision Support Rule Management"
        description="Create, manage, test, and maintain guidance and decision support rules."
        buttonLabel="Open Module"
        path="/support-rule-management"
      />
    </div>
  );
}